import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import type { EGoogleAdsKeywordMatchType } from '@feathr/blackbox';
import { Text } from '@feathr/components';

import { getMatchTypeLabel } from './KeywordFields.utils';

import * as styles from './KeywordMatchTypePill.css';

interface IKeywordMatchTypePillProps {
  matchType: EGoogleAdsKeywordMatchType;
}

/**
 * A keyword's match type, as a status pill to sit inside the keyword's own pill. Belongs to the
 * pill it labels, so it is only ever rendered as a `KeywordPill` child.
 *
 * It is set in uppercase, so anything naming the pill around it should spell the label out
 * rather than leaning on this text.
 *
 * @param props - {@link IKeywordMatchTypePillProps}.
 */
function KeywordMatchTypePill({ matchType }: Readonly<IKeywordMatchTypePillProps>): JSX.Element {
  const { t } = useTranslation();

  return (
    <Text.SmallMedium className={styles.root} inline={true} truncate={false}>
      {getMatchTypeLabel(matchType, t)}
    </Text.SmallMedium>
  );
}

export default KeywordMatchTypePill;
